module.exports = require('./helpers/bundle-url').getBundleURL('51kHd') + "logo.c51670a8.svg";